import styled, { css } from 'styled-components';

import { LINE_HEIGHT_DEFAULT } from 'styles/typography';

import Text from './Text';

/**
 * `overflow: visible` means an unbreakable token (a long word, an ID, a hyphen-free URL) renders
 * straight past the container edge, so `overflow-wrap` has to sit alongside it rather than only on
 * the `multilineCss` consumers.
 */
const sharedCss = css`
  overflow: visible;
  overflow-wrap: break-word;
  white-space: pre-line;
`;

export const multilineCss = css`
  text-align: start;
  text-overflow: unset;
  ${sharedCss}
`;

const MultiLineText = styled(Text)`
  line-height: ${LINE_HEIGHT_DEFAULT};
  ${sharedCss}
`;

export default MultiLineText;
